import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=e99f962e&"
import script from "./rich-editor.vue?vue&type=script&lang=js&"
export * from "./rich-editor.vue?vue&type=script&lang=js&"
import style0 from "./rich-editor.vue?vue&type=style&index=0&id=e99f962e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports